import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';
const CustomerPage = React.lazy(() => import('./CustomerPage'));
const ComplianceAssociation = React.lazy(() =>
  import('./CorporateModule/Compliance Association'),
);
const CorporatePage = React.lazy(() => import('./CorporatePage'));
const VendorPage = React.lazy(() => import('./VendorPage'));
const SettingModule = React.lazy(() =>
  import('./CorporateModule/SettingModule'),
);
const CorportaeModulePage = React.lazy(() =>
  import('./CorporateModule/CorporateMasterPage'),
);
const MasterModule = React.lazy(() => import('./CorporateModule/MasterModule'));
const RouteModule = React.lazy(() => import('./CorporateModule/RouteModule'));
const PendingProfile = React.lazy(() => import('./PendingProfile'));
const TripHistory = React.lazy(() => import('./CorporateModule/trip-history'));
const FeedbackSettingsPage = React.lazy(() => import('./CorporateModule/FeedbackSettings'));
const SafeReachSettingsPage = React.lazy(() => import('./CorporateModule/SafeReachSettings'));

export const CustomerPageConfig = [
  {
    permittedRole: RoutePermittedRole.superAdmin,
    path: '/customers',
    element: <CustomerPage />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/trip-history',
    element: <TripHistory />,
  },
  {
    permittedRole: RoutePermittedRole.superAdmin,
    path: '/compliance-association/:id',
    element: <ComplianceAssociation />,
  },
  {
    permittedRole: RoutePermittedRole.superAdmin,
    path: '/customers/corporates/:id/:logo',
    element: <CorporatePage />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/customers/corporates/vendor-page/:id',
    element: <VendorPage />,
  },
  {
    permittedRole: RoutePermittedRole.superAdmin,
    path: '/customers/corporates/corporate-modules',
    element: <CorportaeModulePage />,
  },
  {
    permittedRole: RoutePermittedRole.superAdmin,
    path: '/customers/masterpage/corporate-modules/master',
    element: <MasterModule />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/customers/masterpage/corporate-modules/route',
    element: <RouteModule />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/customers/masterpage/corporate-modules/setting',
    element: <SettingModule />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/customers/masterpage/pending-request',
    element: <PendingProfile />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/customers/masterpage/vendor-to-driver',
    element: <PendingProfile />,
  },
  {
    permittedRole: RoutePermittedRole.superAdmin,
    path: '/feedback-settings/:id',
    element: <FeedbackSettingsPage />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/safe-reach-settings/:id',
    element: <SafeReachSettingsPage />,
  },
];
